import React from 'react';
import bag from '../.../../../../../../../../../assets/images/bag.svg';

const TypeCard = ({ typeName, name }) => {
  return (
    <div className="d-flex gap-2 client-card justify-content-center">
      <img src={bag} />
      <div>
        <p className="m-0 fs-10">{typeName}</p>
        <p className="m-0 fs-14 fw-semibold" style={{ color: '#405189' }}>
          {name}
        </p>
      </div>
    </div>
  );
};

export default TypeCard;
